import ProjectProvider from '../../core/providers/ProjectProvider';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withGS from '../withGShoc';

class ProjectContainer extends Component {

  render() {

    const { id, data, component } = this.props;
    const WrappedComponent = component;

    return (
      <ProjectProvider value={data}>
        <WrappedComponent
          {...this.props}
          id={id}
          project={id}
          data={data}
        />
      </ProjectProvider>
    );
  }
}

ProjectContainer.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired
};

export default withGS(ProjectContainer);